<template>
  <div>
    <router-link to="/">Home</router-link>
  </div>
</template>

<script>
export default {
  created() {
    const query = this.$route.query;
    const serviceType = localStorage.getItem("serviceType") || null;
    const entryType = localStorage.getItem("entryType") || null;
    if (entryType == "application") {
      if (query.code) {
        let path;
        switch (serviceType) {
          case "DRV_LIC_INTER": // 國際駕照
            path = "/verification/driving";
            break;
          case "HEADMASTER_RENEW": // 校長
          case "COACH_RENEW": // 教練員
            path = `/verification/hc-account/${serviceType}`;
            break;
          case "SCHOOL_RENEW": // 駕校
            path = "/verification/school";
            break;
          case "HZMB_H_FIRST_PERSON": // H類貨車新申請
          case "HZMB_H_FIRST_COMP": // H類貨車新申請
          case "HZMB_H_CANCEL_PERSON": // H類貨車取消申請
          case "HZMB_H_CANCEL_COMP": // H類貨車取消申請
            path = `/verification/hzmb-h-account/${serviceType}`;
            break;
          case "HZMB_CHANGE_PERSON": // 換人換車個人
          case "HZMB_CHANGE_COMP": // 換人換車公司
          case "HZMB_GH_CHANGE_COMP": // 跨境貨運換人換車公司
            path = `/verification/hzmb-change-vd-account/${serviceType}`;
            break;
          default:
            path = "/personal/onePass";
            break;
        }
        this.$router.push({
          path: path,
          query: {
            code: query.code,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: this.$t("message.accountLoginFailed"),
        });
        this.$router.push("/personal");
      }
    } else if (entryType == "search") {
      if (query.code) {
        this.$router.push({
          path: "/search/status",
          query: {
            code: query.code,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: this.$t("message.accountLoginFailed"),
        });
        this.$router.push("/search/personal");
      }
    } else {
      this.$message({
        type: "error",
        message: this.$t("message.accountLoginFailed"),
      });
      this.$router.push("/personal");
    }
  },
};
</script>

<style></style>
